import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as d, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconListen",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, l, _, f, a) {
  return r(), d("svg", {
    "aria-label": l.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--listen"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Listen",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    s("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 2a2.5 2.5 0 0 0-2.49 2.27.5.5 0 1 1-.995-.09 3.5 3.5 0 0 1 6.985.32c0 1.01-.393 1.801-.792 2.346a4.922 4.922 0 0 1-.765.827l-.064.055-.017.015c-.096.095-.247.201-.352.275l-.025.017c-.14.1-.223.16-.255.191l-.104.101-.033.032a5.368 5.368 0 0 0-.144.142 1.201 1.201 0 0 0-.186.23 2.788 2.788 0 0 0-.131.432 11.858 11.858 0 0 0-.099.437 1.7 1.7 0 0 1-.421.782C7.79 10.726 7.275 11 6.5 11c-.462 0-.842-.117-1.144-.318a1.816 1.816 0 0 1-.615-.708 2.343 2.343 0 0 1-.24-.94v-.032C4.5 9 4.5 9 5 9h-.5a.5.5 0 0 1 1-.003v.002-.002.032c.003.028.007.07.016.123.018.108.053.244.118.375a.817.817 0 0 0 .275.323c.12.08.303.15.59.15.515 0 .76-.172.882-.302a.762.762 0 0 0 .137-.205.485.485 0 0 0 .036-.098l.004-.02c.015-.071.053-.255.102-.452.048-.196.123-.478.214-.653a2.15 2.15 0 0 1 .355-.464 9.643 9.643 0 0 1 .293-.287c.102-.102.261-.214.37-.29l.018-.012.004-.003.164-.118a1.579 1.579 0 0 0 .074-.058l.006-.005c.02-.02.051-.048.09-.083.332-.295 1.251-1.113 1.251-2.45A2.5 2.5 0 0 0 8 2ZM3.662 4.338a.5.5 0 0 1 0 .708L2.707 6h2.41a.5.5 0 1 1 0 1h-2.41l.955.955a.5.5 0 1 1-.707.707L1.147 6.854a.5.5 0 0 1 0-.707l1.808-1.809a.5.5 0 0 1 .707 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ o(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=listen.js.map
